<template>
  <section class="main-section p-2 my-5 col-10 offset-1">
    <!-- Title Section -->
    <h2 class="text-center my-3 text-white text-shadow">البحث عن المتقدمين</h2>

    <!-- Search Form -->
    <div class="row">
      <form @submit.prevent="searchApplicant" class="">
        <label for="search-value" class="form-label">بحث عن متقدم</label>
        <div class="d-flex mb-3">
          <input v-model="searchData.searchValue" data-no-asterisk="1" class="form-control w-75 me-3" type="text" id="search-value"
            placeholder="Type to search..." required />
          <button class="btn btn-primary text-white col-md-2 col-3" id="" @click="resetValues()"> بحث <font-awesome-icon
              :icon="['fas', 'magnifying-glass']" /></button>
        </div>
        <div class="container justify-content-center">
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-reg" value="1" checked @change="resetValues()" />
            <label class="form-check-label" for="search-reg">بحث برقم التسجيل</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-reg" value="4" @change="resetValues()" />
            <label class="form-check-label" for="search-reg">بحث باسم السائق</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-nation" value="2" @change="resetValues()" />
            <label class="form-check-label" for="search-nation">بحث بالرقم الوطني</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-phone" value="3" @change="resetValues()" />
            <label class="form-check-label" for="search-phone">بحث برقم الهاتف</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-passport" value="5" @change="resetValues()" />
            <label class="form-check-label" for="search-passport">بحث برقم الجواز</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-autopassport" value="7" @change="resetValues()" />
            <label class="form-check-label" for="search-autopassport">بحث بالرقم الآلي</label>
          </div>
          <div class="form-check form-check-inline">
            <input v-model="searchData.searchKey" class="form-check-input" type="radio" id="search-plate" value="6" @change="resetValues()" />
            <label class="form-check-label" for="search-plate">بحث برقم اللوحة</label>
          </div>
        </div>
      </form>
    </div>

    <hr />

    <!-- Results Section -->

    <div v-if="loading" class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="searchResult?.hasOwnProperty('applicants')" class="row">
      <div v-if="searchResult?.applicants.length > 0" class="table-responsive">
        <h2 class="text-center label">نتائج البحث </h2>
        <table class="main-table table table-bordered">
          <thead>
            <tr>
              <th>رقم التسجيل</th>
              <th>اسم السائق</th>
              <th>رقم الهاتف</th>
              <th>الجنسية</th>
              <th>نوع المركبة</th>
              <!-- <th>طراز المركبة</th> -->
              <th>مركز جمرك</th>
              <th>رقم اللوحة</th>
              <th>حالة الطلب</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(applicant, i) in searchResult.applicants" :key="i" class="bg-blink">
              <td>
                <router-link class="nav-link" :to="'/admin/applicant/'+ applicant.id">{{applicant.id}}</router-link>
              </td>
              <td>
                <router-link class="nav-link"
                  :to="'/admin/applicant/'+ applicant.id">{{applicant.applicantName}}</router-link>
              </td>
              <td>{{ applicant.phoneNo }}</td>
              <td>{{ applicant.nationality }}</td>
              <td>{{ applicant.transMade }}</td>
              <!-- <td>{{ applicant.transModel }}</td> -->
              <td>{{ departs[applicant.departId - 2].name.split(" ").pop() }}</td>
              <td>{{ applicant.plateNo }}</td>
              <td :class="$adminAppStatus[applicant.appType][applicant.status]?.class ">
                {{$adminAppStatus[applicant.appType][applicant.status]?.text }} </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination-controls text-center mt-3">
          <button class="btn btn-primary" :disabled="searchResult.pageNo === 1"
            @click="changePage(searchResult, searchResult.pageNo - 1)">
            السابق
          </button>
          <span class="mx-2">الصفحة {{ searchResult.pageNo }} من {{ searchResult.totalPages }}</span>
          <button class="btn btn-primary" :disabled="searchResult.pageNo === searchResult.totalPages"
            @click="changePage(searchResult, searchResult.pageNo + 1)">
            التالي
          </button>
          <span class="mx-3" title="العدد الإجمالي">{{ (currentCountInView < searchResult?.totalResults) ?
            currentCountInView : searchResult?.totalResults }} من {{ searchResult?.totalResults }}</span>
        </div>
        <hr />
      </div>
    </div>
    <div v-else class="text-center">
      <h3>
        <p class="text-muted">لا توجد نتائج مطابقة.</p>
      </h3>
    </div>

    <div v-if="!loading && searchResult.length === 0 && searchPerformed" class="text-center">
      <p class="text-muted">لا توجد نتائج مطابقة.</p>
    </div>

    <hr />
    <!-- Latest Applicants -->
    <div class="form-label" id="visibility-switcher" @click="toggleIcon()" data-visibility='switcher'
      data-vis-Id="latest-applicants">
      <label class="switcher-text pointer">
        الطلبات الأخيرة
        <font-awesome-icon :icon="dynCaretIcon" />
      </label>
    </div>
    <div v-if="applicantLatest.length" class="row " id="visibility-target" data-visibility="target"
      data-target-vis-Id="latest-applicants">
      <h2 class="text-center label">الطلبات الأخيرة</h2>
      <hr />
      <div v-for="(latestAppData, index) in applicantLatest" :key="index" class="table-responsive">
        <h2 class="text-center label">{{ departs.find(e => e.id === latestAppData.departId)?.name }}</h2>
        <table class="main-table table table-bordered">
          <thead>
            <tr class="">
              <th class="">
                رقم التسجيل
              </th>
              <th class="">
                اسم السائق
              </th>
              <th class="">
                رقم الهاتف
              </th>
              <th class="">
                الجنسية
              </th>
              <th class="">
                نوع المركبة
              </th>
              <th class="">
                طراز المركية
              </th>
              <th class="">
                رقم اللوحة
              </th>
              <th class="">
                حالة الطلب
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(applicant, i) in latestAppData.applicants" :key="i" class="">
              <td>
                <router-link class="nav-link" :to="'/admin/applicant/'+ applicant.id">{{applicant.id}}</router-link>
              </td>
              <td>
                <router-link class="nav-link"
                  :to="'/admin/applicant/'+ applicant.id">{{applicant.applicantName}}</router-link>
              </td>
              <td>
                {{applicant.phoneNo}}
              </td>
              <td>
                {{applicant.nationality}}
              </td>
              <td>
                {{applicant.transMade}}
              </td>
              <td>
                {{applicant.transModel}}
              </td>
              <td>
                {{applicant.plateNo}}
              </td>
              <td :class="$adminAppStatus[applicant.appType][applicant.status]?.class ">
                {{$adminAppStatus[applicant.appType][applicant.status]?.text }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
  
  <script>

  
  export default {
    data() {
      return {
        applicantLatest: [],
        departs: [],
        searchData: {
          searchValue: "", // Value to search for
          searchKey: "1", // Default search type (by registration number)
          pageNo: 1,
          pageSize: 25,
        },
        searchResult: {applicants: []}, // Holds the search results
        loading: false, // Loading state
        searchPerformed: false, // To check if a search has been performed
        caretIcon: "caret-up", // to use in switch-visibility icon
        switchState: 1
      };
    },
    mounted(){
      var targetVisId;
   $("[data-visibility='switcher']").click(function(){
       targetVisId = $(this).attr("data-vis-Id");
       if($("[data-target-vis-Id='"+ targetVisId +"']").hasClass("is-hidden")){
           $("[data-target-vis-Id='"+ targetVisId +"']").slideDown(250).removeClass("is-hidden");
           $(this).children(".switcher-text").children("svg").removeClass("fas fa-caret-down").addClass("fas fa-caret-up");
           // self.$caretIcon = "caret-up"
       }else{
           $("[data-target-vis-Id='"+ targetVisId +"']").slideUp(250).addClass("is-hidden");
           $(this).children(".switcher-text").children("svg").removeClass("fas fa-caret-up").addClass("fas fa-caret-down");
           // self.$caretIcon = "caret-down"
           
       }
       
  });
  /*************************************************/ 
    
    },
    async created() {
      await this.fetchOptions();
      await this.fetchLatestApplicants();
    },
    computed: {
      dynCaretIcon : function(){
        return this.caretIcon;
      }, 
      currentCountInView: function () {
        return this.searchData?.pageSize * this.searchData?.pageNo;
      }
    },
    methods: {
    /** */
    async fetchOptions() {
      if (this.$store.getters.getDeparts.length == 0) {
        await this.$store.dispatch('fetchDeparts'); // Fetch and store in Vuex
      }
      this.departs = this.$store.getters.getDeparts
    },
    /********************************/
    /** */
      async searchApplicant() {
        if (!this.searchData.searchValue) {
          this.$tempAlert("أدخل مفتاح للبحث في حقل البحث",'warning');
          return;
        }
        this.loading = true;
        this.searchPerformed = false;
        try {
          const response = await this.$axios.post(`api/employee/applicant/getapplicantby`, this.searchData);
          if(response.data){
            this.searchResult = response.data.data ?? {};
            if(!document.getElementById("visibility-target").classList.contains("is-hidden")){
              document.getElementById("visibility-switcher").click()
            }            
          }
        } catch (error) {
          console.error("Error fetching searchResult:", error);
          if(error.response?.data){
              this.$tempAlert(error.response.data.msg,'warning');
          }
        } finally {
          this.loading = false;
          this.searchPerformed = true;
        }
      },
      /***************************/
      /** */
      // Change the current page for a specific report section
      changePage(reportAppSection, newPageNo) {
        if (newPageNo >= 1 && newPageNo <= reportAppSection.totalPages) {
          reportAppSection.pageNo = newPageNo;
          this.getReportForSection(reportAppSection);
        }
      },
      /* */
        resetValues() {
            this.reportData = [];
            this.searchData.pageNo = 1;
        },
        /********************/
      // Fetch the report for a specific section based on the page number
        async getReportForSection(reportAppSection) {
            this.searchData.pageNo = reportAppSection.pageNo
            try {
                const response = await this.$axios.post(`api/employee/applicant/getapplicantby`, this.searchData);
                this.searchResult = response.data.data ?? {};
               } catch (error) {
                console.error("Error fetching report for section:", error);
            }
        },
      /********************************/

      async fetchLatestApplicants() {
        try {
          const response = await this.$axios.get("api/employee/applicant/getlatestapplicants/");
          if(response?.data.isSuccess){
            this.applicantLatest = response.data.data;
          }else{
            this.$tempAlert(response?.data.msg,'warning');
          }
        } catch (error) {
          if(error.response?.data){
            this.$tempAlert(error.response?.data.msg,'warning');
          }
          console.error('Error fetching applicant data:', error);
        }
      },
      
      toggleIcon(){
        console.log("s1", this.caretIcon)
          if(this.switchState == 0){
            this.caretIcon = "caret-up"
            this.switchState = 1
          }else{
          this.caretIcon = "caret-down"
          this.switchState = 0
          
        }
        console.log("s2", this.caretIcon)
      },
    }
  };
  </script>
  
  <style>

  .table th,
  .table td {
    text-align: center;
    vertical-align: middle;
  }

  .link, .switcher-text{
    cursor: pointer;
    text-decoration: none;
    }
    .is-hidden{
        display: none;
    }
  </style>